import { jsxs as u, jsx as a, Fragment as H } from "react/jsx-runtime";
import { useRef as K, useCallback as M, useId as ae, useState as V, useEffect as Y } from "react";
import { C as ce } from "./CommentCountBadge-BNeNtSLb.js";
import { Array as O, Map as w } from "yjs";
import { c as B, d as I, C as de } from "./CommentComposer-CmMmKWAF.js";
class L extends Error {
  code;
  constructor(t, n) {
    super(n), this.name = "CommentRepositoryMutationError", this.code = t;
  }
}
function ee() {
  return typeof globalThis.crypto?.randomUUID == "function" ? globalThis.crypto.randomUUID() : Math.random().toString(36).replace(/[^a-z]+/g, "").substring(0, 12);
}
function me(e) {
  return typeof e == "object" && e !== null;
}
function A(e, t) {
  if (e && typeof e == "object") {
    const n = e;
    if (n.kind === "agent" && typeof n.sessionId == "string" && typeof n.sessionName == "string" && typeof n.onBehalfOfUserId == "string")
      return {
        kind: "agent",
        sessionId: n.sessionId,
        sessionName: n.sessionName,
        onBehalfOfUserId: n.onBehalfOfUserId,
        ...typeof n.onBehalfOfDisplayName == "string" ? { onBehalfOfDisplayName: n.onBehalfOfDisplayName } : {}
      };
    if (n.kind === "user" && typeof n.displayName == "string")
      return {
        kind: "user",
        displayName: n.displayName,
        ...typeof n.userId == "string" ? { userId: n.userId } : {}
      };
  }
  return { kind: "user", displayName: t };
}
function le(e, t, n, o, s, l) {
  const c = me(n) ? n : {
    ...l,
    id: n,
    timeStamp: o,
    deleted: s
  };
  return {
    ...c.actor ? { actor: c.actor } : {},
    author: t,
    ...c.clientMutationId ? { clientMutationId: c.clientMutationId } : {},
    content: e,
    deleted: c.deleted === void 0 ? !1 : c.deleted,
    id: c.id === void 0 ? ee() : c.id,
    ...c.replyToCommentId ? { replyToCommentId: c.replyToCommentId } : {},
    timeStamp: c.timeStamp === void 0 ? performance.timeOrigin + performance.now() : c.timeStamp,
    type: "comment"
  };
}
function ue(e, t, n, o, s) {
  return {
    comments: t,
    id: n === void 0 ? ee() : n,
    quote: e,
    ...s === void 0 ? {} : { anchor: s },
    // Threads created before resolve support have no `resolved` field.
    resolved: o === void 0 ? !1 : o,
    type: "thread"
  };
}
function G(e) {
  return {
    ...e.actor ? { actor: e.actor } : {},
    author: e.author,
    ...e.clientMutationId ? { clientMutationId: e.clientMutationId } : {},
    content: "[Deleted Comment]",
    deleted: !0,
    id: e.id,
    ...e.replyToCommentId ? { replyToCommentId: e.replyToCommentId } : {},
    timeStamp: e.timeStamp,
    type: "comment"
  };
}
function z(e, t) {
  return e === void 0 || typeof e == "string" && B(e) <= t;
}
function he(e) {
  if (!e || typeof e != "object" || Array.isArray(e))
    return "unsupported";
  const t = e;
  return t.kind === "text-quote" ? typeof t.exact == "string" && t.exact.length > 0 && B(t.exact) <= I.maxAnchorExactBytes && z(
    t.prefix,
    I.maxAnchorContextBytes
  ) && z(
    t.suffix,
    I.maxAnchorContextBytes
  ) ? "supported" : "unsupported" : t.kind === "entity" && typeof t.entityType == "string" && t.entityType.length > 0 && B(t.entityType) <= I.maxEntityKeyBytes && typeof t.entityId == "string" && t.entityId.length > 0 && B(t.entityId) <= I.maxEntityKeyBytes && z(t.field, I.maxEntityKeyBytes) && z(
    t.labelSnapshot,
    I.maxAnchorExactBytes
  ) ? "supported" : "unsupported";
}
function fe(e) {
  if (e && typeof e == "object" && !Array.isArray(e) && !["text-quote", "entity"].includes(
    String(e.kind)
  ))
    throw new L(
      "ANCHOR_UNSUPPORTED",
      "Unknown comment anchor kinds cannot be authored by this client."
    );
  if (he(e) !== "supported")
    throw new L(
      "ANCHOR_INVALID",
      "The comment anchor is malformed or exceeds its encoded size limit."
    );
}
function R(e) {
  return Array.isArray(e) ? e.map(R) : e && typeof e == "object" ? e instanceof w || e instanceof O ? R(e.toJSON()) : Object.fromEntries(
    Object.entries(e).map(([t, n]) => [
      t,
      R(n)
    ])
  ) : e;
}
function _(e) {
  return Array.isArray(e) ? (e.forEach(_), Object.freeze(e)) : e && typeof e == "object" ? (Object.values(e).forEach(_), Object.freeze(e)) : e;
}
function te(e) {
  return e.actor && Object.freeze(e.actor), Object.freeze(e);
}
function pe(e) {
  return e.comments.forEach(te), Object.freeze(e.comments), e.anchor !== void 0 && _(e.anchor), Object.freeze(e);
}
function W(e) {
  const t = e.get("author");
  return le(
    e.get("content"),
    t,
    e.get("id"),
    e.get("timeStamp"),
    e.get("deleted"),
    {
      actor: A(e.get("actor"), t),
      clientMutationId: e.get("clientMutationId"),
      replyToCommentId: e.get("replyToCommentId")
    }
  );
}
function ye(e) {
  if (e.get("type") !== "thread")
    return W(e);
  const t = e.get("comments"), n = t instanceof O ? t.toArray().filter((s) => s instanceof w).map(W) : [], o = e.has("anchor") ? _(R(e.get("anchor"))) : void 0;
  return ue(
    e.get("quote"),
    n,
    e.get("id"),
    e.get("resolved"),
    // Unknown future kinds intentionally survive materialization. Consumers
    // report them through getCommentAnchorSupport instead of guessing.
    o
  );
}
function E(e) {
  const t = new w();
  if (t.set("type", e.type), t.set("id", e.id), e.type === "comment")
    return e.actor && t.set("actor", e.actor), t.set("author", e.author), e.clientMutationId && t.set("clientMutationId", e.clientMutationId), t.set("content", e.content), t.set("deleted", e.deleted), e.replyToCommentId && t.set("replyToCommentId", e.replyToCommentId), t.set("timeStamp", e.timeStamp), t;
  t.set("quote", e.quote), e.anchor !== void 0 && (fe(e.anchor), t.set("anchor", R(e.anchor))), t.set("resolved", e.resolved);
  const n = new O();
  return e.comments.forEach((o, s) => {
    n.insert(s, [E(o)]);
  }), t.set("comments", n), t;
}
function X(e, t) {
  return e.author === t.author && e.content === t.content && e.deleted === t.deleted && e.replyToCommentId === t.replyToCommentId && JSON.stringify(A(e.actor, e.author)) === JSON.stringify(A(t.actor, t.author));
}
class Ue {
  doc;
  sharedComments;
  listeners = /* @__PURE__ */ new Set();
  snapshot;
  constructor(t) {
    this.doc = t, this.sharedComments = t.getArray("comments"), this.snapshot = this.materializeSnapshot(), this.sharedComments.observeDeep(this.handleSharedChanges);
  }
  getSnapshot() {
    return this.snapshot;
  }
  subscribe(t) {
    return this.listeners.add(t), () => this.listeners.delete(t);
  }
  destroy() {
    this.sharedComments.unobserveDeep(this.handleSharedChanges), this.listeners.clear();
  }
  addThread(t, n = this.sharedComments.length) {
    for (const o of t.comments) {
      const s = o.clientMutationId ? this.findMutation(o.clientMutationId) : void 0;
      if (s) {
        if (s.thread.quote !== t.quote || !X(s.comment, o))
          throw new L(
            "MUTATION_CONFLICT",
            "clientMutationId was already used for a different comment mutation."
          );
        return { duplicate: !0, value: s.thread };
      }
    }
    return this.doc.transact(() => {
      this.sharedComments.insert(n, [E(t)]);
    }, this), {
      duplicate: !1,
      value: this.requireThread(t.id)
    };
  }
  appendReply(t, n, o) {
    if (n.clientMutationId) {
      const f = this.findMutation(n.clientMutationId);
      if (f) {
        if (f.thread.id !== t || !X(f.comment, n))
          throw new L(
            "MUTATION_CONFLICT",
            "clientMutationId was already used for a different comment mutation."
          );
        return { duplicate: !0, value: f.comment };
      }
    }
    const l = this.findThreadMap(t)?.get("comments");
    if (!(l instanceof O))
      throw new Error(`Comment thread ${t} was not found.`);
    const c = o ?? l.length;
    this.doc.transact(() => {
      l.insert(c, [E(n)]);
    }, this);
    const m = this.requireThread(t).comments.find(
      (f) => f.id === n.id
    );
    if (!m) throw new Error(`Comment ${n.id} was not inserted.`);
    return { duplicate: !1, value: m };
  }
  addTopLevelComment(t, n = this.sharedComments.length) {
    this.doc.transact(() => {
      this.sharedComments.insert(n, [E(t)]);
    }, this);
    const o = this.snapshot.find(
      (s) => s.type === "comment" && s.id === t.id
    );
    if (!o || o.type !== "comment")
      throw new Error(`Comment ${t.id} was not inserted.`);
    return o;
  }
  deleteThread(t) {
    const n = this.findThreadIndex(t);
    return n === -1 ? !1 : (this.doc.transact(() => this.sharedComments.delete(n), this), !0);
  }
  deleteTopLevelComment(t) {
    const n = this.snapshot.findIndex(
      (s) => s.type === "comment" && s.id === t
    ), o = this.snapshot[n];
    return n === -1 || !o || o.type !== "comment" ? null : (this.doc.transact(() => this.sharedComments.delete(n), this), {
      index: n,
      markedComment: G(o)
    });
  }
  deleteComment(t, n) {
    const o = this.snapshot.find(
      (m) => m.type === "thread" && m.id === t
    ), s = o?.comments.findIndex((m) => m.id === n) ?? -1;
    if (!o || s === -1) return null;
    const c = this.findThreadMap(t)?.get("comments");
    return c instanceof O ? (this.doc.transact(() => c.delete(s), this), {
      index: s,
      markedComment: G(o.comments[s])
    }) : null;
  }
  setThreadResolved(t, n) {
    const o = this.snapshot.find(
      (l) => l.type === "thread" && l.id === t
    );
    if (!o || o.resolved === n) return !1;
    const s = this.findThreadMap(t);
    return s ? (this.doc.transact(() => s.set("resolved", n), this), !0) : !1;
  }
  createSharedMap(t) {
    return E(t);
  }
  handleSharedChanges = () => {
    this.snapshot = this.materializeSnapshot();
    for (const t of this.listeners) t();
  };
  materializeSnapshot() {
    const t = this.sharedComments.toArray().filter((n) => n instanceof w).map(ye).map(
      (n) => n.type === "thread" ? pe(n) : te(n)
    );
    return Object.freeze(t);
  }
  findThreadIndex(t) {
    return this.sharedComments.toArray().findIndex(
      (n) => n instanceof w && n.get("type") === "thread" && n.get("id") === t
    );
  }
  findThreadMap(t) {
    const n = this.findThreadIndex(t);
    if (n === -1) return;
    const o = this.sharedComments.get(n);
    return o instanceof w ? o : void 0;
  }
  requireThread(t) {
    const n = this.snapshot.find(
      (o) => o.type === "thread" && o.id === t
    );
    if (!n) throw new Error(`Comment thread ${t} was not found.`);
    return n;
  }
  findMutation(t) {
    for (const n of this.snapshot) {
      if (n.type !== "thread") continue;
      const o = n.comments.find(
        (s) => s.clientMutationId === t
      );
      if (o) return { comment: o, thread: n };
    }
  }
}
function $e(e) {
  return e;
}
const Q = [
  "#3e63dd",
  "#8e4ec6",
  "#d6409f",
  "#e5484d",
  "#cf5100",
  "#b5820b",
  "#30a46c",
  "#0d9488",
  "#0091ff",
  "#5f6b7a"
];
function ge(e) {
  let t = 2166136261;
  for (let n = 0; n < e.length; n++)
    t ^= e.charCodeAt(n), t = Math.imul(t, 16777619);
  return t >>> 0;
}
function Ce(e) {
  return Q[ge(e) % Q.length];
}
const be = "#ffffff";
function Ne(e, t = "") {
  const o = `${e} ${t}`.match(/\p{L}|\p{N}/u)?.[0];
  return o ? o.toUpperCase() : "?";
}
function F(e) {
  const t = A(e.actor, e.author);
  return t.kind === "agent" ? t.sessionName : t.displayName;
}
function Ie(e) {
  const t = A(e.actor, e.author);
  return t.kind === "agent" ? t.sessionId : t.userId ?? t.displayName;
}
function Z({ comment: e }) {
  const t = Ie(e);
  return /* @__PURE__ */ a(
    "span",
    {
      "aria-hidden": "true",
      className: "nim-comment-avatar",
      style: {
        background: Ce(t),
        color: be
      },
      children: Ne(F(e), t)
    }
  );
}
function ve({
  comment: e,
  onOpenAgentSession: t
}) {
  const n = A(e.actor, e.author);
  if (n.kind === "user")
    return /* @__PURE__ */ u("span", { className: "nim-comment-actor", children: [
      /* @__PURE__ */ a(Z, { comment: e }),
      /* @__PURE__ */ a("span", { className: "nim-comment-author", children: n.displayName })
    ] });
  const o = /* @__PURE__ */ u(H, { children: [
    /* @__PURE__ */ a(Z, { comment: e }),
    /* @__PURE__ */ a("span", { className: "material-symbols-outlined", children: "smart_toy" }),
    /* @__PURE__ */ a("span", { children: n.sessionName }),
    /* @__PURE__ */ a("span", { className: "nim-comment-agent-badge", children: "Agent" }),
    n.onBehalfOfDisplayName && /* @__PURE__ */ u("span", { className: "nim-comment-agent-owner", children: [
      "for ",
      n.onBehalfOfDisplayName
    ] })
  ] });
  return t ? /* @__PURE__ */ a(
    "button",
    {
      type: "button",
      className: "nim-comment-actor nim-comment-agent-author",
      title: `Open agent session ${n.sessionName}`,
      onClick: (s) => {
        s.stopPropagation(), t(n.sessionId);
      },
      children: o
    }
  ) : /* @__PURE__ */ a("span", { className: "nim-comment-actor nim-comment-agent-author", children: o });
}
function ke(e) {
  try {
    return new Date(e).toLocaleString(void 0, {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit"
    });
  } catch {
    return "";
  }
}
function Me(e, t) {
  const n = e.comments.find(
    (o) => o.id === t.replyToCommentId
  );
  return n ? F(n) : "an earlier comment";
}
const we = {
  orphaned: "What this comment was on is no longer in the document. The conversation is kept.",
  unsupported: "This comment is anchored to something this editor does not understand, likely written by a newer version. The conversation is kept."
};
function Ae(e, t, n) {
  const o = e.comments.length, s = [
    `Comment thread on ${n || "this document"}`,
    `${o} ${o === 1 ? "comment" : "comments"}`
  ];
  return e.resolved && s.push("resolved"), t !== "attached" && s.push("detached"), s.join(", ");
}
function xe({
  thread: e,
  anchorState: t = "attached",
  anchorLabel: n,
  isActive: o,
  canComment: s,
  getMembers: l,
  tabIndex: c = 0,
  cardRef: m,
  autoFocusComposer: f = !1,
  onSelectThread: j,
  onSetThreadResolved: x,
  onDeleteThread: v,
  onDeleteComment: U,
  onReply: $,
  onOpenAgentSession: q
}) {
  const S = K(null), p = n ?? e.quote, b = t !== "attached", y = e.comments.length === 0, T = M(
    () => j(e.id),
    [j, e.id]
  ), g = M(() => {
    if (y) {
      v(e);
      return;
    }
    S.current?.focus();
  }, [y, v, e]), C = M(
    (r) => {
      r.target === r.currentTarget && (r.key === "Enter" || r.key === " ") && (r.preventDefault(), T());
    },
    [T]
  );
  return /* @__PURE__ */ u(
    "div",
    {
      ref: (r) => {
        S.current = r, typeof m == "function" ? m(r) : m && (m.current = r);
      },
      className: "nim-comment-thread" + (o ? " active" : "") + (e.resolved ? " resolved" : "") + (b ? " detached" : ""),
      "data-testid": "comment-thread",
      "data-thread-id": e.id,
      "data-resolved": e.resolved ? "true" : "false",
      "data-anchor-state": t,
      role: "listitem",
      tabIndex: c,
      "aria-current": o ? "true" : void 0,
      "aria-label": Ae(e, t, p),
      onClick: T,
      onKeyDown: C,
      children: [
        /* @__PURE__ */ u("div", { className: "nim-comment-quote", title: p, children: [
          e.resolved && /* @__PURE__ */ a("span", { className: "nim-comment-resolved-badge", title: "Resolved", children: /* @__PURE__ */ a("span", { className: "material-symbols-outlined", children: "check_circle" }) }),
          p || "(no quote)"
        ] }),
        b && /* @__PURE__ */ u("div", { className: "nim-comment-detached-notice", "data-testid": "comment-thread-detached", children: [
          /* @__PURE__ */ a("span", { className: "material-symbols-outlined", children: "link_off" }),
          /* @__PURE__ */ a("span", { children: we[t] })
        ] }),
        e.resolved ? (
          // Resolved threads collapse to a dimmed summary with an Unresolve
          // affordance; comments and the reply composer are hidden until the
          // thread is reopened.
          /* @__PURE__ */ u(
            "div",
            {
              className: "nim-comment-thread-footer",
              onClick: (r) => r.stopPropagation(),
              children: [
                /* @__PURE__ */ u("span", { className: "nim-comment-resolved-summary", children: [
                  e.comments.length,
                  " ",
                  e.comments.length === 1 ? "comment" : "comments",
                  " · Resolved"
                ] }),
                s && /* @__PURE__ */ u(H, { children: [
                  /* @__PURE__ */ a(
                    "button",
                    {
                      type: "button",
                      className: "nim-comment-btn nim-comment-btn-unresolve",
                      onClick: (r) => {
                        r.stopPropagation(), x(e, !1);
                      },
                      children: "Unresolve"
                    }
                  ),
                  /* @__PURE__ */ a(
                    "button",
                    {
                      type: "button",
                      className: "nim-comment-btn nim-comment-btn-delete-thread",
                      title: "Delete thread",
                      onClick: (r) => {
                        r.stopPropagation(), v(e);
                      },
                      children: "Delete"
                    }
                  )
                ] })
              ]
            }
          )
        ) : /* @__PURE__ */ u(H, { children: [
          e.comments.map((r) => /* @__PURE__ */ u("div", { className: "nim-comment", "data-comment-id": r.id, children: [
            /* @__PURE__ */ u("div", { className: "nim-comment-meta", children: [
              /* @__PURE__ */ a(
                ve,
                {
                  comment: r,
                  onOpenAgentSession: q
                }
              ),
              /* @__PURE__ */ a("span", { className: "nim-comment-time", children: ke(r.timeStamp) }),
              s && /* @__PURE__ */ a(
                "button",
                {
                  type: "button",
                  className: "nim-comment-delete",
                  title: "Delete comment",
                  "aria-label": `Delete comment by ${F(r)}`,
                  onClick: (N) => {
                    N.stopPropagation(), U(r, e);
                  },
                  children: /* @__PURE__ */ a("span", { className: "material-symbols-outlined", children: "delete" })
                }
              )
            ] }),
            r.replyToCommentId && /* @__PURE__ */ u("div", { className: "nim-comment-reply-target", children: [
              "Replying to ",
              Me(e, r)
            ] }),
            /* @__PURE__ */ a("div", { className: "nim-comment-content", children: r.content })
          ] }, r.id)),
          s && /* @__PURE__ */ u(
            "div",
            {
              className: "nim-comment-thread-footer",
              onClick: (r) => r.stopPropagation(),
              children: [
                /* @__PURE__ */ a(
                  de,
                  {
                    getMembers: l,
                    submitLabel: y ? "Comment" : "Reply",
                    placeholder: y ? "Add a comment... use @ to mention" : "Reply...",
                    label: y ? `Comment on ${p || "this document"}` : `Reply to the thread on ${p || "this document"}`,
                    autoFocus: y && f,
                    onSubmit: (r, N) => $(e, r, N),
                    onCancel: g
                  }
                ),
                /* @__PURE__ */ a(
                  "button",
                  {
                    type: "button",
                    className: "nim-comment-btn nim-comment-btn-resolve",
                    onClick: (r) => {
                      r.stopPropagation(), x(e, !0);
                    },
                    children: "Resolve"
                  }
                ),
                /* @__PURE__ */ a(
                  "button",
                  {
                    type: "button",
                    className: "nim-comment-btn nim-comment-btn-delete-thread",
                    title: "Delete thread",
                    onClick: (r) => {
                      r.stopPropagation(), v(e);
                    },
                    children: "Delete"
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}
function Se(e) {
  return e.anchorState !== "attached";
}
function Te(e, t) {
  const n = [], o = [], s = [];
  for (const c of e)
    c.thread.resolved ? s.push(c) : Se(c) ? o.push(c) : n.push(c);
  const l = [{ key: "open", heading: null, views: n }];
  return o.length > 0 && l.push({ key: "detached", heading: "Detached", views: o }), t && s.length > 0 && l.push({ key: "resolved", heading: "Resolved", views: s }), l.filter((c) => c.views.length > 0);
}
function ze({
  threads: e,
  activeThreadId: t,
  capabilities: n,
  getMembers: o,
  title: s = "Comments",
  emptyMessage: l,
  headerExtra: c,
  onClose: m,
  defaultShowResolved: f = !0,
  showResolved: j,
  onShowResolvedChange: x,
  autoFocusThreadId: v = null,
  className: U,
  restoreFocusOnUnmount: $ = !0,
  ...q
}) {
  const S = ae(), p = K(null), b = K(/* @__PURE__ */ new Map()), [y, T] = V(f), g = j ?? y, [C, r] = V(null), N = n.comment, J = Te(e, g), h = J.flatMap((i) => i.views), P = e.filter((i) => i.thread.resolved).length, ne = C && h.some((i) => i.thread.id === C) && C || t && h.some((i) => i.thread.id === t) && t || h[0]?.thread.id || null, oe = M(
    (i) => {
      T(i), x?.(i);
    },
    [x]
  );
  Y(() => {
    if (!$) return;
    const i = document.activeElement;
    return () => {
      i?.isConnected && i.focus();
    };
  }, [$]);
  const D = M(
    (i) => {
      const d = h[i];
      d && (r(d.thread.id), b.current.get(d.thread.id)?.focus());
    },
    [h]
  ), se = M(
    (i) => {
      if (i.key === "Escape") {
        m && (i.preventDefault(), m());
        return;
      }
      const d = i.target.closest?.(
        ".nim-comment-thread"
      );
      if (!d || d !== i.target) return;
      const k = h.findIndex(
        (re) => re.thread.id === d.dataset.threadId
      );
      k !== -1 && (i.key === "ArrowDown" ? (i.preventDefault(), D(Math.min(k + 1, h.length - 1))) : i.key === "ArrowUp" ? (i.preventDefault(), D(Math.max(k - 1, 0))) : i.key === "Home" ? (i.preventDefault(), D(0)) : i.key === "End" && (i.preventDefault(), D(h.length - 1)));
    },
    [h, D, m]
  );
  Y(() => {
    if (!C || h.some((d) => d.thread.id === C)) return;
    const i = p.current?.contains(document.activeElement) ?? !1;
    r(null), (i || document.activeElement === document.body) && b.current.get(h[0]?.thread.id ?? "")?.focus();
  }, [h, C]);
  const ie = l ?? (N ? "No comments yet. Select text in the document and add one." : "No comments yet.");
  return /* @__PURE__ */ u(
    "section",
    {
      className: U ? `nim-comments-panel ${U}` : "nim-comments-panel",
      "data-testid": "comments-panel",
      "aria-labelledby": S,
      children: [
        /* @__PURE__ */ u("div", { className: "nim-comments-panel-header", children: [
          /* @__PURE__ */ a(
            "span",
            {
              "aria-hidden": "true",
              className: "material-symbols-outlined nim-comments-panel-icon",
              children: "chat_bubble"
            }
          ),
          /* @__PURE__ */ a("span", { className: "nim-comments-panel-title", id: S, children: s }),
          /* @__PURE__ */ a(ce, { count: e.length }),
          c,
          P > 0 && /* @__PURE__ */ a(
            "button",
            {
              type: "button",
              className: "nim-comments-panel-filter",
              "data-testid": "comments-panel-resolved-filter",
              "aria-pressed": g,
              title: g ? "Hide resolved threads" : "Show resolved threads",
              "aria-label": g ? `Hide ${P} resolved threads` : `Show ${P} resolved threads`,
              onClick: () => oe(!g),
              children: /* @__PURE__ */ a("span", { "aria-hidden": "true", className: "material-symbols-outlined", children: g ? "check_circle" : "radio_button_unchecked" })
            }
          ),
          m && /* @__PURE__ */ a(
            "button",
            {
              type: "button",
              className: "nim-comments-panel-close",
              onClick: m,
              "aria-label": "Close comments",
              title: "Close",
              children: /* @__PURE__ */ a("span", { "aria-hidden": "true", className: "material-symbols-outlined", children: "close" })
            }
          )
        ] }),
        !N && /* @__PURE__ */ a("div", { className: "nim-comments-panel-notice", role: "status", children: "You have read-only access to this document." }),
        /* @__PURE__ */ a(
          "div",
          {
            className: "nim-comments-panel-list",
            ref: p,
            onKeyDown: se,
            children: h.length === 0 ? /* @__PURE__ */ a("div", { className: "nim-comments-empty", children: ie }) : J.map((i) => /* @__PURE__ */ u(
              "div",
              {
                className: `nim-comments-group nim-comments-group-${i.key}`,
                role: "list",
                "aria-label": i.heading ? `${i.heading} threads` : s,
                children: [
                  i.heading && /* @__PURE__ */ a("div", { className: "nim-comments-group-heading", "aria-hidden": "true", children: i.heading }),
                  i.views.map((d) => /* @__PURE__ */ a(
                    xe,
                    {
                      thread: d.thread,
                      anchorState: d.anchorState,
                      anchorLabel: d.anchorLabel,
                      isActive: d.thread.id === t,
                      canComment: N,
                      getMembers: o,
                      tabIndex: d.thread.id === ne ? 0 : -1,
                      autoFocusComposer: d.thread.id === v,
                      cardRef: (k) => {
                        k ? b.current.set(d.thread.id, k) : b.current.delete(d.thread.id);
                      },
                      ...q
                    },
                    d.thread.id
                  ))
                ]
              },
              i.key
            ))
          }
        )
      ]
    }
  );
}
export {
  be as A,
  ze as C,
  Ue as Y,
  ve as a,
  xe as b,
  Ce as c,
  Ne as d,
  F as e,
  $e as f,
  Te as g,
  E as h,
  Se as i,
  le as j,
  ue as k,
  he as l,
  A as n
};
//# sourceMappingURL=CollaborativeCommentsPanel-Cf27858R.js.map
